import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { getPermissionFlags } from "utils/permissions";

export const useQuestions = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const user = useSelector((state) => state.user);
  const { showLocation } = getPermissionFlags(user);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const [location, setLocation] = useState(""); // Store the location being edited

  return {
    isLargeScreen,
    open,
    editMode,
    handleOpen,
    handleClose,
    setOpen,
    showLocation,
    page,
    setPage,
    limit,
    setLimit,
    search,
    setSearch,
    sort,
    setSort,
    searchInput,
    setSearchInput,
    location,
    setLocation,
  };
};
